import AppPagination from '../../../../components/AppPagination'

export default function DashboardRightDrawer({
  open,
  title,
  subtitle = '',
  onClose,
  widthClassName = 'max-w-[700px]',
  children,
  headerExtra = null,
  page = 1,
  totalPages = 1,
  onPrevious = null,
  onNext = null,
  onPageChange = null,
}) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-[210] bg-black/45 backdrop-blur-[2px]" onClick={onClose} role="presentation">
      <aside
        className={`absolute right-0 top-0 h-full w-full overflow-y-auto border-l border-outline-variant/30 bg-surface-container-lowest shadow-[0_26px_50px_rgba(15,23,42,0.35)] ${widthClassName}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="sticky top-0 z-10 border-b border-outline-variant/25 bg-surface-container-lowest px-6 py-5">
          <div className="mb-3 flex items-start justify-between gap-4">
            <div>
              <h3 className="text-4xl font-extrabold tracking-tight text-on-surface">{title}</h3>
              {subtitle ? <p className="mt-1 text-sm text-on-surface-variant">{subtitle}</p> : null}
            </div>
            <button
              type="button"
              onClick={onClose}
              className="material-symbols-outlined rounded-lg p-1 text-on-surface-variant hover:bg-surface-container-low hover:text-on-surface"
              aria-label="Close drawer"
            >
              close
            </button>
          </div>
          {headerExtra}
        </div>

        <div className="px-6 py-6">{children}</div>

        {onPrevious && onNext && onPageChange ? (
          <div className="border-t border-outline-variant/25 px-6 py-4">
            <AppPagination
              page={page}
              totalPages={totalPages}
              canPrevious={page > 1}
              canNext={page < totalPages}
              onPrevious={onPrevious}
              onNext={onNext}
              onPageChange={onPageChange}
            />
          </div>
        ) : null}
      </aside>
    </div>
  )
}
